import apiProxy from "@shared/utils/api-proxy.ts";
import { ResponseType } from "@shared/services/partners/partnerSubscription/response.ts";

export default async (subscriptionId: number) => {
  const response: Record<string, unknown> | null = await apiProxy.post(
    `partner/subscription`,
    { subscriptionId },
  );

  if (!response) {
    throw new Error("Got no response from server");
  }

  return response as ResponseType;
};
